import request from '@/utils/request';
const baseURL = '/api/posclient/';

//------------掛單相關-----------
//單一訂單掛單
export function pendingEachOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}pendingOrder`,
    data,
  });
}
//取得掛單列表
export function listPendingOrder() {
  return request({
    method: 'post',
    url: `${baseURL}listPendingOrder`,
  });
}
//取回訂單
export function restoreOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}restoreOrder`,
    data: {
      order_id: data,
    },
  });
}
//延遲訂單
export function setOrderDelay(data) {
  return request({
    method: 'post',
    url: `${baseURL}setOrderDelay`,
    data,
  });
}

//------------內部訂單相關-----------
//取得內部訂單列表
export function listIncomingOrder(type) {
  return request({
    method: 'post',
    url: `${baseURL}listIncomingOrder`,
    data: {
      type,
      source: 'inner',
    },
  });
}
//取得外部訂單列表
export function listOutsideOrder(type) {
  return request({
    method: 'post',
    url: `${baseURL}listIncomingOrder`,
    data: {
      type,
      source: 'outside',
    },
  });
}
//接單
export function acceptOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}acceptOrder`,
    data: {
      order_id: data,
    },
  });
}
//拒單
export function rejectOrder(data) {
  return request({
    method: 'post',
    url: `${baseURL}rejectOrder`,
    data,
  });
}
//取得設定: 拒單原因、遲單原因
export function reasonList() {
  return request({
    method: 'get',
    url: `${baseURL}application/config`,
  });
}
